// @i18n-ignore-file
export const TEST_LOCATORS = {
  // product form
  SLIDER_IMAGES_MAIN_IMAGE: 'slider-images-main-image',
  CART_POPUP_PRODUCT_FORM: 'cart-popup-product-form',
  CART_POPUP_BACKDROP: 'cart-popup-backdrop',
  CART_ICON_COUNT: 'cart-icon-count',
  PRODUCT_CTA: 'product-cta',

  //bundle form
  BUNDLE_DISCOUNT: 'bundle-discount',
  BUNDLE_ADD_TO_CART: 'bundle-add-to-cart',
  BUNDLE_PRODUCT_LIST: 'bundle-product-list',
  BUNDLE_PRODUCT_SALE_PRICE: 'bundle-product-sale-price',

  BUNDLE_OPTIONAL_PRODUCTS: 'bundle-optional-products',
  BUNDLE_OPTIONAL_PRODUCTS_DETAILS: 'bundle-optional-products-details',

  //size chart
  SIZE_CHART_BUTTON: 'size-chart-button',
  SIZE_CHART: 'size-chart',

  // reviews
  FIRST_FOLD_REVIEW_COUNT: 'first-fold-review-count',
  REVIEW_SECTION_REVIEW_COUNT: 'review-section-review-count',
  REVIEW_SECTION_WRITE_REVIEW_BUTTON: 'review-section-write-review-button',
  REVIEW_STARS_WRAPPER: 'review-stars-wrapper',

  // wishlist
  WISHLIST_ICON_COUNT: 'wishlist-icon-count',
  ADD_TO_WISHLIST_BUTTON: 'add-to-wishlist-button',
  REMOVE_FROM_WISHLIST_BUTTON: 'remove-from-wishlist-button',

  // collection
  COLLECTION_FILTER: 'collection-filter',
  COLLECTION_PRODUCT_COUNT: 'collection-product-count',
  COLLECTION_BREADCRUMB: 'collection-breadcrumb',
  FILTER_SECTION_APPLIED_FILTERS: 'filter-section-applied-filters',
  FILTER_SECTION_CLEAR_ALL: 'filter-section-clear-all',
  COLLECTION_INFINITE_LOADER: 'collection-infinite-loader',
  COLLECTION_TITLE: 'collection-title',

  // product card
  PRODUCT_CARD: 'product-card',

  // Cart
  CART_DELETE_ITEM: 'cart-delete-item',
  HEADER_CART_ICON: 'header-cart-icon',
  HEADER_SEARCH_ICON: 'header-search-icon',
  CART_POPUP_CHECKOUT_BUTTON: 'cart-popup-checkout-button',

  // Search
  NO_SEARCH_RESULTS: 'no-search-results',

  // Global
  // Rich text
  RICH_TEXT_MOBILE: 'rich-text-mobile',
  RICH_TEXT_DESKTOP: 'rich-text-desktop',

  // Brand logo
  BRAND_LOGO: 'brand-logo',

  // Locale switcher
  LOCALISATION_CTA: 'localisation-cta',
  CHANGE_COUNTRY: 'change-country',
  LOCALE_SWITCHER_FORM: 'locale-switcher-form',

  // Mobile menu
  MOBILE_MENU_SUBMENU: 'mobile-menu-submenu',
}
